import { IField } from '@framework/ui/Organisms/FinalForm/validators/interfaces/Field';
import { IRule } from '@framework/ui/Organisms/FinalForm/validators/interfaces/Rule';

export const combineFieldsWithValues = (
  fields: IField[],
  values: { [key: string]: string },
): {
  [key: string]: {
    displayName: string,
    fieldCaption: string,
    fieldName: string,
    value: string,
  },
} => fields.reduce((acc, { fieldName, fieldCaption }) => {
  const value = values[fieldName];
  const fieldWithValue = { [fieldName]: { fieldName, fieldCaption, value } };
  return { ...acc, ...fieldWithValue };
}, {});

export const groupValidators = (...validatorsList: any[]): Record<string, string> => validatorsList.reduce(
  (validationSummary, currentValidator) => Object.assign(validationSummary, currentValidator),
  {},
);

/**
 * Use this helper, if you need to apply a validation to more than 1 field.
 */
interface IApplyValidatorToMultipleFields {
  fields: IField[],
  values: {},
  validator: (params: object) => {},
  getErrorKey?: (field: IField) => string,
}

export const applyValidatorToMultipleFields = (
  { fields, values, validator, getErrorKey }: IApplyValidatorToMultipleFields,
): object => fields.reduce<Record<string, string>>(
  (errors, field) => {
    const validationResult = validator(
      {
        value: (values as Record<string, unknown>)[field.fieldName],
        ...field,
      },
    );

    if (validationResult) {
      errors[getErrorKey ? getErrorKey(field) : field.fieldName] = (validationResult as Record<string, string>)[field.fieldName];
    }

    return errors;
  },
  {},
);

export const fieldsArrayValidator = (
  rules: IRule[],
  fields: { collection: IField[] },
): ({ [key: string]: string })[] => {
  const membersArrayErrors: ({ [key: string]: string })[] = [];
  const inputErrors: Record<string, any> = {};

  for (let memberIndex = 0; memberIndex < fields.collection.length; memberIndex++) {
    let field = fields.collection[memberIndex];
    const memberErrors: Record<string, string> = {};
    rules.forEach((rule) => {
      rule.functionValidation.forEach((func) => {
        let error = func.name({
          ...func.params,
          fieldName: rule.fieldName,
          fieldCaption: rule.fieldCaption,
          value: (field as any)[rule.fieldName],
          allValue: field,
          allFieldsValue: fields,
          inputErrors,
        });

        if (!memberErrors[rule.fieldName] && error) {
          memberErrors[rule.fieldName] = (error as Record<string, string>)[rule.fieldName];
        }
      });
    });

    if (Object.keys(memberErrors).length) {
      // @ts-ignore
      membersArrayErrors[memberIndex] = memberErrors;
    }
  }

  return membersArrayErrors;
};
